import React, { FC } from 'react'
import { VStack, Textarea, Input } from '@chakra-ui/react'
import { Button, Icon } from '../../components'
import theme from '../../styles'
import { useTranslation } from 'react-i18next'

export interface TextareaReferralCodeProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}

export const TextareaReferralCode: FC<TextareaReferralCodeProps> = ({ placeholder, onChange, name }) => {
  const { t } = useTranslation()
  const [titleValue, setTitleValue] = React.useState('')
  const [textareaValue, setTextareaValue] = React.useState('')
  const [referralCodeValue, setReferralCodeValue] = React.useState('')

  const handleInputTitleChange = (event: any) => {
    setTitleValue(event.target.value)
  }

  const handleInputMessageChange = (event: any) => {
    setTextareaValue(event.target.value)
  }

  const handleReferralCodeChange = (event: any) => {
    const value = event.target.value
    const regex = /^[a-zA-Z0-9#]*$/
    if (regex.test(value)) {
      setReferralCodeValue(value)
    }
  }

  return (
    <VStack spacing={3} marginY={8} width="100%" gridRowGap={4}>
      <Input
        value={titleValue}
        onChange={handleInputTitleChange}
        placeholder={t('common_add-title')}
        maxLength={50}
        variant="none"
        maxWidth={460}
        height={41}
        minHeight="auto"
        size="lg"
        border="2px solid"
        borderColor="grey"
        backgroundColor="transparent"
        _placeholder={{ color: 'green.500' }}
        fontSize={14}
        autoFocus
        onClick={(e) => {
          e.stopPropagation()
          e.currentTarget.focus()
        }}
      />
      <Textarea
        value={textareaValue}
        onChange={handleInputMessageChange}
        placeholder={placeholder}
        variant="none"
        maxWidth={460}
        height={170}
        name={name}
        size="lg"
        border="2px solid"
        borderColor="grey"
        backgroundColor="transparent"
        _placeholder={{ color: 'green.500' }}
        fontSize={14}
        autoFocus
        onClick={(e) => {
          e.stopPropagation()
          e.currentTarget.focus()
        }}
      />
      <Input
        value={referralCodeValue}
        onChange={handleReferralCodeChange}
        placeholder={t('common_referral-code')}
        variant="none"
        maxWidth={460}
        height={41}
        minHeight="auto"
        size="lg"
        border="2px dashed"
        borderColor="grey"
        backgroundColor="transparent"
        _placeholder={{ color: 'green.500' }}
        fontSize={14}
        autoFocus
        onClick={(e) => {
          e.stopPropagation()
          e.currentTarget.focus()
        }}
      />
      <Button
        role={'button'}
        layerStyle={theme.LayerStyles.SMALL_PILL}
        onClick={() => {
          onChange && onChange([titleValue, textareaValue, referralCodeValue])
        }}
      >
        <Icon icon="arrow-right" color="white" />
      </Button>
    </VStack>
  )
}
